import { SxProps, Theme } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { gridFilterPanelSxProps } from './styles';

export function getFilterPanelRootSx(
  filterPanelSx?: SxProps<Theme>
): SxProps<Theme> {
  return filterPanelSx
    ? mergeSx(gridFilterPanelSxProps, filterPanelSx)
    : gridFilterPanelSxProps;
}
